import { createRoot } from 'react-dom/client';
import { merge } from 'lodash';

merge(
  window.ReactAppEnv,
  // Local dev environment overrides can be read from .env.local
  {
    client: {
      version: import.meta.env.VITE_CLIENT_VERSION,
      build: import.meta.env.VITE_CLIENT_BUILD,
    },
    api: {
      uri: import.meta.env.VITE_API_SERVER_URI,
    },
    auth: {
      UserPoolId: import.meta.env.VITE_AUTH_USER_POOL_ID,
      ClientId: import.meta.env.VITE_AUTH_CLIENT_ID,
    },
  },
);

Promise.all([import('./app/AppPreload')]).then(
  ([{ App, createHistory, Router }]) => {
    const history = createHistory();

    createRoot(document.getElementById('root')).render(
      <Router history={history}>
        <App />
      </Router>,
    );
  },
);
